import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import { FaHeart, FaMapMarkerAlt, FaArrowRight } from "react-icons/fa";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { useNavigate } from "react-router-dom";

export default function Wishlist() {
    const [wishlist, setWishlist] = useState([]);
    const navigate = useNavigate();

    // =========================================================
    // REMOVE FROM WISHLIST
    // =========================================================
    const removeFromWishlist = (id) => {
        const updated = wishlist.filter((item) => item.id !== id);

        setWishlist(updated);

        localStorage.setItem(
            "wishlist",
            JSON.stringify(updated)
        );
    };

    // =========================================================
    // LOAD WISHLIST
    // =========================================================
    useEffect(() => {
        const stored =
            JSON.parse(localStorage.getItem("wishlist")) || [];

        setWishlist(stored);
    }, []);

    return (
        <div className="min-h-screen bg-[#F7F5EF]">

            {/* =====================================================
                HERO
            ===================================================== */}
            <Hero
                heightClass="h-[180px] sm:h-[220px] md:h-[240px] lg:h-[250px]"
                title="Wishlist"
                backgroundImage={heroImg}
                contentClass=""
            />


            {/* =====================================================
                WISHLIST SECTION
            ===================================================== */}
            <section className="w-full bg-[#F7F5EF] py-14 sm:py-16 lg:py-20">

                <div
                    className="
                        mx-auto
                        max-w-[1440px]
                        px-5
                        sm:px-8
                        lg:px-12
                        xl:px-16
                    "
                >

                    {/* =================================================
                        SECTION HEADER
                    ================================================= */}
                    <div className="mb-10 sm:mb-12">

                        <div className="flex items-center gap-3">

                            <span className="h-px w-8 bg-[#B78932]" />

                            <span
                                className="
                                    text-[11px]
                                    font-bold
                                    uppercase
                                    tracking-[0.22em]
                                    text-[#0B5552]
                                "
                            >
                                Saved Stays
                            </span>

                        </div>


                        <div
                            className="
                                mt-4
                                flex
                                flex-col
                                gap-4
                                sm:flex-row
                                sm:items-end
                                sm:justify-between
                            "
                        >

                            <div>

                                <h2
                                    className="
                                        font-serif
                                        text-3xl
                                        font-medium
                                        leading-tight
                                        text-[#173F3E]
                                        sm:text-4xl
                                        lg:text-[42px]
                                    "
                                >
                                    My Wishlist
                                </h2>

                                <p
                                    className="
                                        mt-3
                                        max-w-2xl
                                        text-sm
                                        leading-7
                                        text-[#69736F]
                                        sm:text-base
                                    "
                                >
                                    Keep the hotels you love close at hand
                                    and return whenever you're ready to
                                    plan your Dubai stay.
                                </p>

                            </div>


                            {/* Wishlist Count */}
                            {wishlist.length > 0 && (
                                <div
                                    className="
                                        inline-flex
                                        w-fit
                                        items-center
                                        gap-2
                                        rounded-full
                                        border
                                        border-[#DED8CC]
                                        bg-[#FBFAF6]
                                        px-4
                                        py-2
                                        text-xs
                                        font-bold
                                        uppercase
                                        tracking-[0.12em]
                                        text-[#173F3E]
                                    "
                                >
                                    <FaHeart className="text-[#B78932]" />

                                    {wishlist.length}{" "}
                                    {wishlist.length === 1
                                        ? "Saved Hotel"
                                        : "Saved Hotels"}
                                </div>
                            )}

                        </div>

                    </div>


                    {/* =================================================
                        EMPTY WISHLIST
                    ================================================= */}
                    {wishlist.length === 0 ? (

                        <div
                            className="
                                flex
                                min-h-[400px]
                                flex-col
                                items-center
                                justify-center
                                rounded-[28px]
                                border
                                border-[#DED8CC]
                                bg-[#FBFAF6]
                                px-6
                                py-20
                                text-center
                            "
                        >

                            {/* Icon */}
                            <div
                                className="
                                    flex
                                    h-20
                                    w-20
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-[#D5A33C]/30
                                    bg-[#F3EBDD]
                                    text-[#B78932]
                                "
                            >
                                <FaHeart className="text-2xl" />
                            </div>


                            <h3
                                className="
                                    mt-6
                                    font-serif
                                    text-2xl
                                    font-medium
                                    text-[#173F3E]
                                "
                            >
                                Your Wishlist is Empty
                            </h3>


                            <p
                                className="
                                    mt-2
                                    max-w-md
                                    text-sm
                                    leading-7
                                    text-[#69736F]
                                    sm:text-base
                                "
                            >
                                Save your favorite hotels while exploring
                                Dubai and they'll appear here for easy
                                access later.
                            </p>


                            {/* Explore Button */}
                            <button
                                type="button"
                                onClick={() => navigate("/hotels")}
                                className="
                                    group
                                    mt-7
                                    inline-flex
                                    items-center
                                    gap-3
                                    rounded-full
                                    bg-[#173F3E]
                                    px-6
                                    py-3.5
                                    text-sm
                                    font-bold
                                    text-white
                                    shadow-[0_10px_25px_rgba(23,63,62,0.15)]
                                    transition-all
                                    duration-300
                                    hover:-translate-y-0.5
                                    hover:bg-[#0B5552]
                                    hover:shadow-[0_15px_30px_rgba(23,63,62,0.22)]
                                "
                            >
                                Explore Hotels

                                <span
                                    className="
                                        flex
                                        h-7
                                        w-7
                                        items-center
                                        justify-center
                                        rounded-full
                                        bg-[#B78932]
                                        text-[#173F3E]
                                        transition-transform
                                        duration-300
                                        group-hover:translate-x-1
                                    "
                                >
                                    <FaArrowRight className="text-[10px]" />
                                </span>

                            </button>

                        </div>

                    ) : (

                        /* =================================================
                           HOTEL GRID
                        ================================================= */
                        <div
                            className="
                                grid
                                grid-cols-1
                                gap-7
                                sm:grid-cols-2
                                lg:grid-cols-3
                            "
                        >

                            {wishlist.map((hotel) => (

                                <div
                                    key={hotel.id}
                                    onClick={() =>
                                        navigate(
                                            `/hotels/${hotel.slug}`
                                        )
                                    }
                                    className="
                                        group
                                        cursor-pointer
                                        overflow-hidden
                                        rounded-[26px]
                                        border
                                        border-[#DED8CC]
                                        bg-[#FBFAF6]
                                        shadow-[0_8px_30px_rgba(23,63,62,0.06)]
                                        transition-all
                                        duration-500
                                        hover:-translate-y-2
                                        hover:border-[#CDBB99]
                                        hover:shadow-[0_20px_50px_rgba(23,63,62,0.13)]
                                    "
                                >

                                    {/* =================================================
                                        IMAGE
                                    ================================================= */}
                                    <div
                                        className="
                                            relative
                                            h-[250px]
                                            w-full
                                            overflow-hidden
                                            sm:h-[260px]
                                        "
                                    >

                                        <img
                                            src={`https://marinadubai.com/uploads/hotels/${hotel.image}`}
                                            alt={hotel.name}
                                            className="
                                                h-full
                                                w-full
                                                object-cover
                                                transition-transform
                                                duration-700
                                                group-hover:scale-105
                                            "
                                        />


                                        {/* Dark Luxury Overlay */}
                                        <div
                                            className="
                                                absolute
                                                inset-0
                                                bg-gradient-to-t
                                                from-[#173F3E]/75
                                                via-[#173F3E]/10
                                                to-transparent
                                            "
                                        />


                                        {/* =================================================
                                            LOCATION BADGE
                                        ================================================= */}
                                        <div
                                            className="
                                                absolute
                                                left-4
                                                top-4
                                                z-10
                                            "
                                        >

                                            <span
                                                className="
                                                    inline-flex
                                                    items-center
                                                    gap-2
                                                    rounded-full
                                                    border
                                                    border-white/30
                                                    bg-[#FBFAF6]/95
                                                    px-3
                                                    py-2
                                                    text-xs
                                                    font-semibold
                                                    text-[#173F3E]
                                                    shadow-lg
                                                    backdrop-blur-md
                                                "
                                            >
                                                <FaMapMarkerAlt
                                                    className="text-[#B78932]"
                                                />

                                                {hotel.location ||
                                                    "Dubai, UAE"}
                                            </span>

                                        </div>


                                        {/* =================================================
                                            REMOVE BUTTON
                                        ================================================= */}
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                removeFromWishlist(
                                                    hotel.id
                                                );
                                            }}
                                            className="
                                                absolute
                                                right-4
                                                top-4
                                                z-20
                                                flex
                                                h-10
                                                w-10
                                                items-center
                                                justify-center
                                                rounded-full
                                                border
                                                border-white/30
                                                bg-[#173F3E]/85
                                                text-white
                                                shadow-lg
                                                backdrop-blur-md
                                                transition-all
                                                duration-300
                                                hover:scale-110
                                                hover:bg-[#B78932]
                                                hover:text-[#173F3E]
                                            "
                                            aria-label="Remove from wishlist"
                                        >
                                            <FaHeart className="text-sm" />
                                        </button>


                                        {/* =================================================
                                            RATING
                                        ================================================= */}
                                        <div
                                            className="
                                                absolute
                                                bottom-4
                                                left-4
                                                z-10
                                            "
                                        >

                                            <div
                                                className="
                                                    flex
                                                    items-center
                                                    gap-2
                                                    rounded-xl
                                                    border
                                                    border-white/20
                                                    bg-[#FBFAF6]/95
                                                    px-3
                                                    py-2
                                                    shadow-lg
                                                    backdrop-blur-md
                                                "
                                            >

                                                <span className="text-[#B78932]">
                                                    ★
                                                </span>

                                                <span
                                                    className="
                                                        text-sm
                                                        font-bold
                                                        text-[#173F3E]
                                                    "
                                                >
                                                    {hotel.rating || "4.5"}
                                                </span>

                                                <span
                                                    className="
                                                        text-[10px]
                                                        uppercase
                                                        tracking-wider
                                                        text-[#69736F]
                                                    "
                                                >
                                                    Excellent
                                                </span>

                                            </div>

                                        </div>


                                        {/* =================================================
                                            PRICE
                                        ================================================= */}
                                        <div
                                            className="
                                                absolute
                                                bottom-4
                                                right-4
                                                z-10
                                                rounded-2xl
                                                bg-[#173F3E]
                                                px-4
                                                py-2.5
                                                text-white
                                                shadow-xl
                                            "
                                        >

                                            <p
                                                className="
                                                    text-[9px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-[0.14em]
                                                    text-[#D5A33C]
                                                "
                                            >
                                                From
                                            </p>

                                            <p
                                                className="
                                                    mt-0.5
                                                    text-sm
                                                    font-bold
                                                "
                                            >
                                                AED{" "}
                                                {Math.round(
                                                    hotel.price_per_night
                                                )}

                                                <span
                                                    className="
                                                        ml-1
                                                        text-[10px]
                                                        font-normal
                                                        text-white/60
                                                    "
                                                >
                                                    / night
                                                </span>
                                            </p>

                                        </div>

                                    </div>


                                    {/* =================================================
                                        CARD CONTENT
                                    ================================================= */}
                                    <div className="p-5 sm:p-6">

                                        {/* Hotel Name */}
                                        <h3
                                            className="
                                                line-clamp-1
                                                font-serif
                                                text-xl
                                                font-medium
                                                text-[#173F3E]
                                                transition-colors
                                                duration-300
                                                group-hover:text-[#0B5552]
                                            "
                                        >
                                            {hotel.name}
                                        </h3>


                                        {/* Location */}
                                        <div
                                            className="
                                                mt-2
                                                flex
                                                items-center
                                                gap-2
                                                text-[#69736F]
                                            "
                                        >

                                            <FaMapMarkerAlt
                                                className="
                                                    text-xs
                                                    text-[#B78932]
                                                "
                                            />

                                            <span className="text-sm">
                                                {hotel.location ||
                                                    "Dubai, UAE"}
                                            </span>

                                        </div>


                                        {/* Divider */}
                                        <div
                                            className="
                                                my-5
                                                h-px
                                                bg-[#E7DED0]
                                            "
                                        />


                                        {/* Description */}
                                        <p
                                            className="
                                                min-h-[48px]
                                                line-clamp-2
                                                text-sm
                                                leading-6
                                                text-[#69736F]
                                            "
                                        >
                                            {hotel.short_description?.replace(
                                                /<[^>]*>/g,
                                                ""
                                            )}
                                        </p>


                                        {/* =================================================
                                            AMENITIES
                                        ================================================= */}
                                        <div
                                            className="
                                                mt-5
                                                flex
                                                flex-wrap
                                                gap-2
                                            "
                                        >

                                            <span
                                                className="
                                                    rounded-full
                                                    bg-[#F3EBDD]
                                                    px-3
                                                    py-1.5
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-wider
                                                    text-[#0B5552]
                                                "
                                            >
                                                🏊 Pool
                                            </span>

                                            <span
                                                className="
                                                    rounded-full
                                                    bg-[#F3EBDD]
                                                    px-3
                                                    py-1.5
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-wider
                                                    text-[#0B5552]
                                                "
                                            >
                                                📶 WiFi
                                            </span>

                                            <span
                                                className="
                                                    rounded-full
                                                    bg-[#F3EBDD]
                                                    px-3
                                                    py-1.5
                                                    text-[10px]
                                                    font-semibold
                                                    uppercase
                                                    tracking-wider
                                                    text-[#0B5552]
                                                "
                                            >
                                                🍽 Restaurant
                                            </span>

                                        </div>


                                        {/* =================================================
                                            VIEW HOTEL BUTTON
                                        ================================================= */}
                                        <div className="mt-6">

                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    e.stopPropagation();

                                                    navigate(
                                                        `/hotels/${hotel.slug}`
                                                    );
                                                }}
                                                className="
                                                    group/button
                                                    flex
                                                    w-full
                                                    items-center
                                                    justify-center
                                                    gap-3
                                                    rounded-full
                                                    bg-[#173F3E]
                                                    px-5
                                                    py-3.5
                                                    text-sm
                                                    font-bold
                                                    text-white
                                                    transition-all
                                                    duration-300
                                                    hover:bg-[#0B5552]
                                                    hover:shadow-[0_10px_25px_rgba(23,63,62,0.18)]
                                                "
                                            >
                                                View Hotel Details

                                                <span
                                                    className="
                                                        flex
                                                        h-7
                                                        w-7
                                                        items-center
                                                        justify-center
                                                        rounded-full
                                                        bg-[#B78932]
                                                        text-[#173F3E]
                                                        transition-transform
                                                        duration-300
                                                        group-hover/button:translate-x-1
                                                    "
                                                >
                                                    <FaArrowRight className="text-[10px]" />
                                                </span>

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>

                    )}

                </div>

            </section>


            {/* =====================================================
                FOOTER
            ===================================================== */}
            <Footer />

        </div>
    );
}